import { appStorage } from '@ilteducation/storage';
import { Realm } from './constants';

export type RealmState = {
  selectedRealm: string;
};

const realmStateKey = 'ilt-config.realm';
export const getPersistedRealm = (): RealmState | undefined => {
  const state = appStorage.getItem(realmStateKey);

  if (!state) {
    return undefined;
  }

  return JSON.parse(state);
};

export const persistSelectedRealm = (selectedRealm: Realm) => {
  const state = getPersistedRealm() ?? {};
  const newState: RealmState = {
    ...state,
    selectedRealm,
  };

  appStorage.setItem(realmStateKey, JSON.stringify(newState));
};
